import { Box as BoxMantine, NavLink as NavLinkMantine } from '@mantine/core'
import styled from 'styled-components'

import IconeBase from '../../Icone'

const TRANSITION_DEFAULT = 'all 0.2s ease'

export const Box = styled(BoxMantine)`
  .mantine-NavLink-children {
    padding-left: 0px !important;
  }
`

const BaseNavLink = styled(NavLinkMantine)`
  transition: ${TRANSITION_DEFAULT};
  color: ${({ theme }) => theme.cor9};

  &:hover {
    background-color: ${({ theme }) => theme.cor3};
  }

  & > .mantine-NavLink-rightSection,
  .mantine-NavLink-rightSection {
    padding-right: 3px !important;
    display: flex;
    align-items: center;
  }

  &[data-active='true'] {
    color: ${({ theme }) => theme.selecionadoFonteIconeMenu};
  }
`

export const NavLinkMenu = styled(BaseNavLink)`
  height: 70px;

  .mantine-Text-root,
  .mantine-NavLink-label {
    font-weight: 500;
    line-height: 70px;
    font-size: 16px;
    font-family: 'RobotoMedium';
    white-space: nowrap;
  }

  &[data-active='true'] {
    background-color: ${({ theme }) => theme.cor3} !important;

    &:hover {
      background-color: ${({ theme }) => theme.cor3};
    }
  }

  ${(props) =>
    props.opened &&
    `
    background-color: ${props.theme.cor3} !important;
    
    &:hover {
      background-color: ${props.theme.cor3} !important;
    }
  `}
`

export const NavLinkSubMenu = styled(BaseNavLink).withConfig({
  shouldForwardProp: (prop) => !['leftSection'].includes(prop)
})`
  background-color: ${({ theme }) => theme.selecionadoBgMenu} !important;
  height: 45px;
  padding-left: 24px;

  .mantine-Text-root,
  .mantine-NavLink-label {
    font-weight: 400;
    line-height: 70px;
    font-size: 16px;
    font-family: 'RobotoMedium';
    white-space: nowrap;
  }

  &:hover {
    background-color: ${({ theme }) => theme.cor7} !important;
  }
`

export const NavLinkSubMenuNv2 = styled(BaseNavLink).withConfig({
  shouldForwardProp: (prop) => !['leftSection'].includes(prop)
})`
  background-color: ${({ theme }) => theme.selecionadoBgMenu} !important;
  height: 45px;
  padding-left: 48px !important;

  .mantine-Text-root,
  .mantine-NavLink-label {
    font-weight: 300;
    line-height: 70px;
    font-size: 16px;
    font-family: 'RobotoMedium';
    white-space: nowrap;
  }

  &:hover {
    background-color: ${({ theme }) => theme.cor7} !important;
  }
`

export const Container = styled.div`
  width: 220px;
`

export const CircleIcon = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  transition: ${TRANSITION_DEFAULT};
  flex-shrink: 0;
`

export const ContainerIcon = styled.div`
  padding-left: 3px;
  padding-right: ${({ minimized }) => (minimized ? '10px' : '0px')};
`

export const ContainerIconSubMenu = styled.div``

export const Icone = styled(IconeBase).attrs(({ active }) => ({
  color: active ? 'primary' : 'default',
  width: '26px',
  height: '26px'
}))`
  ${({ active, theme }) =>
    active &&
    `
    svg, path {
      fill: ${theme.selecionadoFonteIconeMenu} !important;
    }
  `}
`

export const IconeSubMenu = styled(IconeBase).attrs(({ active }) => ({
  color: active ? 'primary' : 'default',
  width: '20px',
  height: '20px'
}))`
  ${({ active, theme }) =>
    active &&
    `
    svg, path {
      fill: ${theme.selecionadoFonteIconeMenu} !important;
    }
  `}
`
